import {
  all,
  call,
  delay,
  fork,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError, toastSuccess } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import {
  LOGGERS_MANAGEMENT_ACTIONS,
  deleteLoggerCleanState,
  deleteLoggerError,
  deleteLoggerSuccess,
  getLoggers,
  getLoggersError,
  getLoggersSuccess,
} from './actions';

function* getLoggersSaga() {
  try {

    const url = `${ApiConstants.BASE_URL}${ApiConstants.LOGGERS_MANAGEMENT}`;
    const response = yield call(requests.getRequest, url, {});

    const { deviceAlarmSettings, isSnoozeExpired } = yield select(
      (state) => state.User
    );

    yield put(
      getLoggersSuccess({
        records: response,
        alarmSettings: { isSnoozeExpired, deviceAlarmSettings },
      })
    );
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getLoggersError(e));
  }
}

function* addLoggerSaga({ payload: data }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.LOGGERS_MANAGEMENT}`;
    const response = yield call(requests.postRequest, url, data);
    yield put({
      type: LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER_SUCCESS,
      payload: response,
    });
    toastSuccess(
      TextConstants.Common.AddedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Logger
      )
    );
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put({
      type: LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER_ERROR,
    });
  }
}

function* updateLoggerSaga({ payload: data, callback }) {
  try {
    const { deviceId, ...updateData } = data;
    const url = `${ApiConstants.BASE_URL}${ApiConstants.UNITS}/${deviceId}`;
    yield call(requests.patchRequest, url, updateData, true);
    yield put({ type: LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_SUCCESS });
    toastSuccess(
      TextConstants.Common.EditedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Logger
      )
    );
    if (callback) callback();
    yield put(getLoggers());
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put({
      type: LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_ERROR,
      payload: e.message,
    });
  } finally {
    yield delay(500);
    yield put({ type: LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_CLEAN_STATE });
  }
}

function* deleteLoggerSaga({ payload: loggerId, callback }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.UNITS}/${loggerId}`;
    yield call(requests.deleteRequest, url);
    yield put(deleteLoggerSuccess(loggerId));
    toastSuccess(
      TextConstants.Common.DeletedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Logger
      )
    );
    callback?.();
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(deleteLoggerError(e));
  } finally {
    yield delay(500);
    yield put(deleteLoggerCleanState());
  }
}

export function* LoggersManagementSaga() {
  yield takeLatest(LOGGERS_MANAGEMENT_ACTIONS.GET_LOGGERS, getLoggersSaga);
  yield takeLatest(LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER, addLoggerSaga);
  yield takeLatest(LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER, updateLoggerSaga);
  yield takeLatest(LOGGERS_MANAGEMENT_ACTIONS.DELETE_LOGGER, deleteLoggerSaga);
}

export default function* rootSaga() {
  yield all([fork(LoggersManagementSaga)]);
}
